import React from 'react';
import { XMarkIcon, ExclamationTriangleIcon, LightBulbIcon } from '@heroicons/react/24/outline';

const typeLabel = (type) => (type === 'suggestion' ? 'Suggestion' : 'Problème');

const typeBadgeClass = (type) =>
  type === 'suggestion' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800';

const userLabel = (user) => {
  if (!user) return 'Utilisateur supprimé';
  return `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.phone_number || 'Utilisateur';
};

const formatDateTime = (dateString) => {
  if (!dateString) return null;
  return new Date(dateString).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ReportDetailModal = ({ report, onClose }) => {
  if (!report) return null;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-xl font-bold text-gray-800">Détail du signalement</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Fermer"
          >
            <XMarkIcon className="h-6 w-6 text-gray-500" />
          </button>
        </div>

        <div className="p-6 space-y-5">
          <div>
            <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${typeBadgeClass(report.type)}`}>
              {report.type === 'suggestion' ? (
                <LightBulbIcon className="h-3.5 w-3.5" />
              ) : (
                <ExclamationTriangleIcon className="h-3.5 w-3.5" />
              )}
              {typeLabel(report.type)}
            </span>
          </div>

          <div>
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Utilisateur</p>
            <p className="text-sm text-gray-800 mt-1">
              {userLabel(report.user)}
              {report.user?.phone_number && (
                <span className="text-gray-500"> · {report.user.phone_number}</span>
              )}
            </p>
          </div>

          <div>
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Message</p>
            <p className="text-sm text-gray-800 mt-1 whitespace-pre-wrap leading-relaxed">
              {report.message}
            </p>
          </div>

          <div>
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Envoyé le</p>
            <p className="text-sm text-gray-800 mt-1">{formatDateTime(report.created_at)}</p>
          </div>

          <div>
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Statut</p>
            {report.read_at ? (
              <p className="text-sm text-gray-800 mt-1">
                Lu le {formatDateTime(report.read_at)}
                {report.read_by_admin && (
                  <span> par {report.read_by_admin.firstname} {report.read_by_admin.lastname}</span>
                )}
              </p>
            ) : (
              <p className="text-sm text-red-700 mt-1 font-medium">Non lu</p>
            )}
          </div>
        </div>

        <div className="flex justify-end p-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportDetailModal;
